<template>
  <div>
    <header-image
      :headerContents="headerContents"
      :headerBackground="'research'"
    />

    <rare-research-box
      :title="'Social Mobility'"
      :content="'Our 2013 research on social mobility led to the Contextual Recruitment System (CRS), now used by the majority of elite graduate employers in the UK. The CRS has meant 61% more people from disadvantaged backgrounds entering the elite professions.'"
      :image="require('@/assets/img/research/research-page/social-mobility.png')"
      :side="'right'"
      :url="'/static/research/2013_Social_Mobility_in_Graduate_Recruitment.pdf'"
      :tabIndex="20"
    />

    <rare-research-box
      :title="'Unconscious Bias'"
      :content="'Our 2014 research led to a further five years of investigation into workplace bias. Working with psychologists, sociologists, academics and a neuroscientist, we tested a series of prototypes in law firms and financial organisations. In late stage testing, 80% of participants had their biases identified and disrupted.<br/><br/>This research led directly to the creation of our Hemisphere training, which has now been completed by tens of thousands of people.'"
      :image="require('@/assets/img/research/research-page/unconscious-bias.png')"
      :side="'left'"
      :url="'/static/research/2014_UB_in_graduate_recruitment.pdf'"
      :tabIndex="21"
    />

    <rare-research-box
      :title="'Ethnicity Stay Gap'"
      :content="'Our 2020 research into the ethnicity stay gap led to the Race Fairness Commitment (RFC), which has been signed by thirty leading employers. For the first time, everyone at those organisations will get a clear message on race and racism at least once a year, and signatory organisations will carry out rigorous monitoring on an ongoing basis.'"
      :image="require('@/assets/img/research/research-page/ethnicity-stay-gap.png')"
      :side="'right'"
      :url="'/static/research/2020_Closing_the_ethnicity_staygap_v2.pdf'"
      :tabIndex="22"
    />

    <rare-research/>

    <rare-awards/>
  </div>
</template>

<script>

import HeaderHeroImage from '../../components/header/HeaderHeroImage';
import RareCallOutBox from '../../components/commonSections/RareCallOutBox';
import researchCarousel from '../../components/carousels/researchCarousel';
import RareAwards from '../../components/carousels/awardsCarousel';

import RareResearchBox from './components/RareResearchBox';

export default {
  name: 'research',
  components: {
    'header-image': HeaderHeroImage,
    'call-out-box': RareCallOutBox,
    'rare-awards': RareAwards,
    'rare-research': researchCarousel,
    'rare-research-box': RareResearchBox,
  },
  data() {
    return {
      headerContents: 'rare-research-header-contents',
    };
  },
  mounted() {
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/research/research.vue